import { connect } from 'react-redux';
import qs from 'qs';

import withPurchase from 'decorators/withPurchase';
import LineItemTransfer from './LineItemTransfer';
import {
  getSearchPurchases,
  getIsAdmin,
  getSubmitSucceeded,
  getPurchaseLineItems,
} from 'reducers';
import {
  findPurchase,
  searchPurchases,
  transferLineItems,
  fetchPurchaseLineItems,
} from 'actions/purchases';

const mapStateToProps = (state, { purchaseId, location: { search } }) => {
  const lineItemsPage =
    qs.parse(search, { ignoreQueryPrefix: true })?.lineItemsPage || 1;
  const lineItems = getPurchaseLineItems(state, purchaseId, lineItemsPage);

  return {
    lineItemsPage,
    lineItems,
    isAdmin: getIsAdmin(state),
    purchases: getSearchPurchases(state),
    submitSucceeded: getSubmitSucceeded(state, 'transferLineItem'),
  };
};

const mapDispatchToProps = {
  fetchPurchaseLineItems,
  searchPurchases,
  transferLineItems,
  findPurchase,
};

export default withPurchase(
  connect(mapStateToProps, mapDispatchToProps)(LineItemTransfer),
);
